<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <component :is="integration.components.promotions" :model="model" />
  </rest-page>
</template>

<script>
import RestPage from '@/common/components/rest/RestPage'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'IntegrationPromotions',

  components: {
    RestPage
  },

  data() {
    return {
      model: null
    }
  },

  props: {
    integration: {
      type: Object,
      required: true
    },

    modelId: {
      type: Number,
      required: true
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `integrations/${this.modelId}`,
        handler: data => {
          this.model = data
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/pages/IntegrationPromotions.vue